import { render, staticRenderFns } from "./retailDetail.vue?vue&type=template&id=5bad216e&scoped=true"
import script from "./retailDetail.vue?vue&type=script&lang=js"
export * from "./retailDetail.vue?vue&type=script&lang=js"
import style0 from "./retailDetail.vue?vue&type=style&index=0&id=5bad216e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bad216e",
  null
  
)

export default component.exports